import React from "react";
import "./SideNavigationBarInfo.css";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function Info() {
  return (
    <div>
      <div className="sidenavigationbarinfo">
        <InfoOutlinedIcon />
        <h3>About SInC</h3>
      </div>
    </div>
  );
}

export default Info;
